<template>
    <div class="options">
       
        <a class="option-picker picker"
           ref="optionselect"
           @click="openOptions()"
           :style="{
           backgroundImage:
           'url(' +
           this.productInfo.options[0].productOptions
           .find((o)=>
            o.productOptionId == this.userProduct.optionId)
            .productOptionOverlay +
            ')',
            }"
            :title="
            'Selected Options : ' +
            this.productInfo.options[0].productOptions.find(
            (o) => o.productOptionId == this.userProduct.optionId
            ).productOptionName
            "
            >
            <span>{{this.productInfo.options[0].productOptions.find(o => o.productOptionId == this.userProduct.optionId).productOptionName}}</span>
        </a>
        <div v-if="active == true" class="popup">
            <div class="popup-content">
                <!--<h2>Leather &amp; Buckle Options</h2>-->
                <div ref="carousel" class="option-list">
                    <div v-for="(o, index) in productInfo.options[0].productOptions"
                         :data-id="o.productOptionId"
                         :data-index="index"
                         :key="o.productOptionId"
                         v-on:click="setOption(o.productOptionId, index)"
                         v-bind:class="[
              'option',
              { selected: o.productOptionId == userProduct.optionId },
            ]"
                         :ref="'option-' + o.productOptionId">
                        <div>
                            <div>
                                <img :alt="o.productOptionName"
                                     :src="o.productOptionOverlay" />
                            </div>
                        </div>
                        <label>
                            {{ o.productOptionName }}
                        </label>
                    </div>
                </div>
            </div>
            <div class="overlay" @click="active = false"></div>
        </div>
    </div>
</template>
<script>
    import { mapState } from "vuex";

    import Globals from "@/globals.js";
    import UserProduct from "../objects/UserProduct";
    export default {
        name: "Options",
        data() {
            return {
                active: false,
                optionOverlay: "",
                appRoot: Globals.appRoot,
            };
        },
        computed: {
            ...mapState(["productInfo", "userProduct"]),
        },
        mounted: function () { },
        components: {  },
        methods: {
            setOption(oId, index) {
                this.$store.dispatch("setUserProductOption", oId);
                this.active = false;
            },
            openOptions() {
                this.active = true;
            },
        },
    };
</script>
<style>
    .option-list {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        margin: 1em;
        grid-gap: .5em;
    }
    .option {
        padding: 4px 0;
        position: relative;
        cursor:pointer;
    }

        .option > div {
            position: relative;
            border-radius: 2px;
            padding: 2px;
            outline: solid 2px #eee;
        }

        .option:hover > div {
            outline: solid 2px #ccc;
        }

        .option.selected > div {
            outline: solid 2px #666;
            /* height: 100%; */
            /* width: 100%; */
        }

        .option > div > div {
            overflow: hidden;
            height: 60px;
            padding: 0;
            background: #fff;
            position: relative;
            border-radius: 2px;
        }

        .option img {
            position: absolute;
            left: 43%;
            top: 50%;
            transform: translate(-50%, -50%);
            height: calc(100% - 1em);
        }
    .key-fob .option img {
        transform: translate(-10%, -50%);
        height: calc(100%);
    }

    .option:hover img {
        height: calc(100% - 0.75em);
    }
    .key-fob .option:hover img {
        height: calc(100% + .25em);
    }

        .option.selected label {
            display: block;
        }

    .product-selections .option label {
        font-size: 0.7rem;
        padding: 0.5em 0 0;
        width: 100%;
        line-height: 1rem;
        /*visibility: hidden;*/
    }

    .option:hover label {
        display: block;
        color: #9f9f9f;
        visibility: visible;
    }

    .options .popup .popup-content {
        padding-bottom: 0;
    }

    button.slick-arrow {
        top: calc(50% - 1.75rem);
    }
</style>
